module.exports = __webpack_public_path__ + "static/img/odnnary-red-scheme.56b2e0c7.jpg";